import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import Modal from 'react-modal'

import { darken } from 'polished'

export const ModalComponent = styled(Modal).attrs({
  style: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 120,
    },
  },
})`
  position: absolute;
  top: 20%;
  left: 20%;
  right: 20%;
  bottom: 20%;
  max-width: 500px;
  padding: 25px;
  height: fit-content;
  overflow-y: auto;
  border-radius: 20px;
  background: #fff;
  margin: auto;
  max-height: 100%;
  ${down('md')} {
    width: 100%;
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
  }
`
export const Container = styled.div``

export const Content = styled.div<{ maxWidth?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px;
  svg {
    cursor: pointer;
  }
  img {
    cursor: pointer;
  }
`

export const Title = styled.div`
  font-size: 17.526px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  color: ${({ theme }) => theme.colors.primary};
`

export const SubTitle = styled.div`
  color: ${({ theme }) => darken(-0.2, theme.colors.primary)};
  font-size: 13.684px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`

export const ContentBody = styled.div`
  overflow-y: auto;
  max-height: 800px;
`

export const TitleHeader = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.title};
`
